/*eslint-disable*/
import { takePaymentStyles } from '../../stylesJS/makeStyles';
import { RACButton, Grid, useMediaQuery } from '@rentacenter/racstrap';
import { useHistory } from 'react-router';
import { OtherActionComponent } from './otherAction/OtherAction';
import { OtherIncomeComponent } from './otherIncome/OtherIncome';
import React, { useContext, useEffect, useState } from 'react';
import { agreementContext } from '../context/PaymentInformationContext';
import { ToggleClub } from './ToggleClub';
import { TextPayPopup } from './TextPayPopup';
import { AcceptPayment } from './AcceptPayment';
import { getNonInvSalesOptions } from '../../api/user';
import { NonInventorySaleDropDownResponse } from '../interface/nonInventorySaleInterface';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { DeliveryContext } from '../../context/DeliveryContext';
import { AppRoute } from '../../config/route-config';
import CONSTANTS from '../constants/constant';
import { LocationParams, ParamType } from '../interface/commonInterface';
import { continueAMClicked } from './CommitmentContinueOnClick';
import {useTranslation} from 'react-i18next';
import VoidAgreement from './voidagreement';
import {getAgreementInfo} from '../../api/user';

export default function PaymentFooter(props: any) {
  /**
   * PF_PS_NO_4
   * Declaration of the state variables and destructuring of context is performed.
   */
  const { customerId, agreementId: rawAgreementId } = useParams<ParamType>();
  // Sanitize: strip any query params that may have leaked into the path param (e.g. spendLimitId)
  const agreementId = rawAgreementId?.split('?')[0];

  const classes = takePaymentStyles();
  const isInRange = useMediaQuery(
    '(min-width:600px) and (max-width:1280px)'
  );
  const history = useHistory();
  const{t}=useTranslation('Payment');
  const {
    nonInventorySaleInfo,
    setNonInventorySaleInfo,
    customerOrderPayment,
    multiStoreSelected,
    agreementDetails,
    customerInfo
  } = useContext(agreementContext);  

  const { paymentSearchValue } = useContext(DeliveryContext);
  const [searchVal, setsearchVal] = paymentSearchValue;
  const [redirectToAccountManagement, setRedirectToAccountManagement] = useState(false);
  const location = useLocation<LocationParams>();
  const urlParams = new URLSearchParams(window.location.search);
  const isCommitment = urlParams.get('origin');
  const { featureFlags } = useContext(agreementContext);
  
  const [agreementStatus, setAgreementStatus] = useState('');

  const [VoidEnabled, setVoidEnabled] = useState(false);
  const [IsAgreementVoided, setIsAgreementVoided] = useState(false);
  const [isDeliveryComplete, setIsDeliveryComplete] = useState('0');
  const [voidAgreementId, setVoidAgreementId] = useState('');
  const [paymentCount, setPaymentCount] = useState(0);

  const pull_data = (data) => {
    setIsAgreementVoided(data);
    // eslint-disable-next-line no-console
    console.log('agreementDetails void', data);
  };
  
  /**
   * PF_PS_NO_5 - PF_PS_NO_8
   * This useEffect is used to fetch the Non-Inventory sale options and
   * update it to context.
   */
  useEffect(() => {
    if (!nonInventorySaleInfo.typeDropDownResp.length) {
      (async () => {
        const typeDropDownResp: NonInventorySaleDropDownResponse =
          await getNonInvSalesOptions({
            salesType: CONSTANTS.EMPTY_STRING,
            provider: CONSTANTS.EMPTY_STRING,
          });
        //   setNonInventorySaleInfo({...nonInventorySaleInfo,typeDropDownResp:typeDropDownResp.data})
        if (typeDropDownResp.status == 200) {
          setNonInventorySaleInfo({
            ...nonInventorySaleInfo,
            typeDropDownResp: typeDropDownResp.data,
          });
        }
      })();
    }
  }, []);

  const getAgrStatus = async () => {
    try {
      const agrInfoResult = await getAgreementInfo(voidAgreementId);
      setAgreementStatus(agrInfoResult?.data?.agreementInformation?.agreementStatusRefCode);
      setIsDeliveryComplete(agrInfoResult?.data?.agreementWorkflow?.isDeliveryCompleted);
      setPaymentCount(agrInfoResult?.data?.agreementInformation?.paymentCount);
      setVoidEnabled(true);
    } catch (error) {
      console.error('Error fetching agreement info:', error);
    }
  };

  useEffect(() => {
    // Extract only the numeric agreementId, stripping any query params that may leak from routing
    const sanitizedAgreementId = agreementId?.split('?')[0];
    if (
      sanitizedAgreementId !== undefined &&
      sanitizedAgreementId !== null &&
      sanitizedAgreementId !== "" &&
      sanitizedAgreementId !== "0"
    ) {
      setVoidAgreementId(sanitizedAgreementId);
    } else if (props.selectedAgreement && props.selectedAgreement?.length === CONSTANTS.ONE_NUMBER) {
      setVoidAgreementId(props.selectedAgreement[0].agreementId);
    } else {
      setVoidAgreementId('');
    }

  }, [props, agreementId]);

  useEffect(() => {
    if (voidAgreementId && voidAgreementId !== '0') {
      getAgrStatus();
    }
  }, [voidAgreementId]);
  
  /**
   * @returns
   * PF_PS_NO_9
   * The cancleOnclick() method is invoked when the user clicks the cancle button
   */
  const cancelOnclick = () => {
    console.log('location', location)
    if (location?.state?.redirectSource === 'am') {
      setRedirectToAccountManagement(true);
    }
    else if (urlParams.get('spendLimitId')) {
      // Local Sourcing prelim payment flow: navigate back to dashboard
      history.push('/dashboard/homepage');
    }
    else redirectionTopaymentsearch()
  };

  const redirectionTopaymentsearch = () => {
    const request = searchVal;
    request.cancelClick = false;
    setsearchVal(request);
    history.push({
      pathname: `/payment1/paymentsearch`,
    });
  };


  if (redirectToAccountManagement) {
    return (
      <Redirect
        to={{
          pathname: AppRoute.AccountManagement.replace(
            ':customerId',
            location?.state?.accountManagementCustomerId ||
            CONSTANTS.EMPTY_STRING
          ),
          state: {
            ...(location?.state || {}),
            redirectSource: 'payment',
          },
        }}
      />
    );
  }

  return (
    <Grid>
      <Grid item className={classes.floatLeft}>
        <RACButton
          type="button"
          color="primary"
          variant="outlined"
          data-testid="Cancel_id"
          onClick={() => cancelOnclick()}
        >
         {t("Cancel")} 
        </RACButton>
      </Grid>
      <Grid item className={`${classes.floatRight} ${classes.displayFlex}`}>
        {/**
         * PF_PS_NO_10 - PF_PS_NO_13
         * This component helps to render the other action button
         */}
        {VoidEnabled === true && IsAgreementVoided !== true && featureFlags?.EnablePreDeliveryCancellation === '1' 
          && isDeliveryComplete !=='1' && voidAgreementId !== '' ? (
          <VoidAgreement
          AgreementId={voidAgreementId}
          customerId={customerId}
          COVoidFlow={agreementStatus}
          paymentCount={paymentCount}
          func={pull_data}
          />
        ) : null}

        {customerOrderPayment == CONSTANTS.EMPTY_STRING ? (
          <>
            <Grid
              item
              className={`${classes.btngroup} ${classes.floatLeft}`}
              role="group"
              data-testid="OtherActionsId"
            >
              <OtherActionComponent />
            </Grid>
            <Grid
              item
              className={`${classes.btngroup} ${classes.floatLeft} ${classes.displayFlex}`}
              role="group"
            >
              {/**
               * PF_PS_NO_14 - PF_PS_NO_17'
               * This component helps to render the other income button.
               */}
              {!isInRange && (isCommitment == undefined) ?
                <OtherIncomeComponent /> : null}


              {/**PF_PS_NO_18
               * This club helps to render the Activate/Deactivate club button.
               */}
              {!isInRange && featureFlags.MXStoreIdentifier !== "1" && <ToggleClub />}
            </Grid>
          </>
        ) : null}
        {/**
         * PF_PS_NO_19
         * This component helps to render the Txt2Pay button
         */}
        {!isInRange && customerOrderPayment == CONSTANTS.EMPTY_STRING && (isCommitment == undefined) ? (
          <TextPayPopup />
        ) : null}


        {/**
         * PF_PS_NO_20
         * This component helps to render the Accept Payment button.
         */}
        {(isCommitment == undefined) ? <AcceptPayment /> : <RACButton
          color="primary"
          variant="contained"
          className={classes.ms2}
          disabled={multiStoreSelected}
          onClick={() => continueAMClicked(agreementDetails, location, customerInfo, history)}
        >
          {" "}
         {t("Continue")} 
        </RACButton>}
      </Grid>
    </Grid>
  );
}


